export const REVERSAL_REASONS = [
  "DUPLICATE",
  "INCORRECT_AMOUNT",
  "INCORRECT_ACCOUNT",
] as const;

export type ReversalReason = (typeof REVERSAL_REASONS)[number];

export const REVERSAL_REASON_LABELS: Record<ReversalReason, string> = {
  DUPLICATE: "Duplicate entry",
  INCORRECT_AMOUNT: "Wrong dollar amount",
  INCORRECT_ACCOUNT: "Wrong recipient",
};

export const REVERSAL_REASON_FLUENT_IDS = {
  INCORRECT_AMOUNT: "reversal-reason-incorrect-amount",
  INCORRECT_ACCOUNT: "reversal-reason-incorrect-account",
  DUPLICATE: "reversal-reason-duplicate",
} as const;
